export type MfPath = string[];

export const mfPath2str = (path: MfPath) => path.join(".");

export const str2MfPath = (s: string) => s.split(".");
